// import components
import {
  Box,
  BoxProps,
  styled,
  Typography,
  TypographyProps
} from '@mui/material';

export const StyledKbdTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    fontWeight: 'bold',
    textTransform: 'uppercase',
    backgroundColor: theme.vars.palette.dusk.onContainer,
    display: 'inline-flex',
    padding: theme.spacing(0.25, 1.5),
    borderRadius: theme.spacing(1),
    fontFamily: 'monospace',
    boxShadow: `0px 2px 0px ${theme.vars.palette.dawn.onFixed}`,
    border: `1px solid ${theme.vars.palette.dawn.onFixed}`,
    minHeight: '22px',
    alignItems: 'center',
    justifyContent: 'center'
  })
);

export const StyledKbdBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));
